let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("caNsL")).then(() => parcelRequire('hclSI'));